<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <div class="pull-left">
                  <h4 class="card-title float-left" v-if="expert2.id && expert2.id > 0">{{$t('expert2.edit.title')}}</h4>
                  <h4 class="card-title float-left" v-else>{{$t('expert2.add.title')}}</h4>
                </div>
              </div>
            </div>
            <div class="row"  v-if="expert2.id && expert2.id > 0 && expert2.status==='Rejected'">
              <div class="col-12">
                <div class="alert alert-danger">
                  <strong>Бекор қилинган!</strong> Бекор қилиш сабаби: <i> {{expert2.reasonDesc}}</i>
                </div>
              </div>
            </div>
            <div class="row" v-if="expert2.id && expert2.id > 0">
              <div class="col-12">
                <button @click="addEditItem"
                        class="all-btn add-btn pull-right ml-2 mr-2"
                        v-if="hasPermission('EXPERT2_EDIT')">
                  <i class="fa fa-table"></i>
                  <span>Эксперт литр</span>
                </button>
                <router-link :to="{path: `/expert2/requirement/edit/${expert2.id}`, query: {hasEdit: true}}"
                             class="all-btn dark-btn pull-right"
                             v-if="hasPermission('EXPERT2_EDIT')">
                  <i class="fa fa-table"></i>
                  <span>{{$t('expert2.field.act')}}</span>
                </router-link>
              </div>
            </div>
            <div class="row" v-if="showReportButton">
              <div class="col-12 btns-box">
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('EXPERT2_CONCLUSION_WORD_QR_CODE')"
                    @click="expert2ReportDocQrCode(expert2)">
                  <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{$t("realEstate.report.titleWordQrCode")}}
                </button>
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('EXPERT2_CONCLUSION_WORD')"
                    @click="expert2ReportDoc(expert2)">
                  <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{$t("realEstate.report.titleWord")}}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('EXPERT2_CONCLUSION_PDF_QR_CODE')"
                        @click="expert2ReportPdfQrCode(expert2)">
                  <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{$t("realEstate.report.titleQrCode")}}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('EXPERT2_CONCLUSION_PDF')"
                        @click="expert2ReportPdf(expert2)">
                  <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{$t("realEstate.report.title")}}
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>{{$t('expert2.field.organizationName')}} <span class="red">*</span></label>
                  <input type="text" class="form-control" v-model="expert2.organizationName"/>
                </div>
                <!--                                <div class="form-group">
                                                    <label>{{$t('expert2.field.orgInn')}} <span class="red">*</span></label>
                                                    <the-mask class="form-control" v-model="expert2.orgInn" mask="#########" masked="masked"></the-mask>
                                                </div>-->
                <!--<div class="form-group">-->
                <!--<label>{{$t('expert2.field.owner')}} <span class="red">*</span></label>-->
                <!--<input type="text" class="form-control" v-model="expert2.owner"/>-->
                <!--</div>-->
                <div class="form-group" v-if="expert2.borrower">
                  <label>Қарз олувчи</label>
                  <span class="form-control">{{ expert2.borrower.borrowerName ? expert2.borrower.borrowerName : expert2.borrower.borrowerName}}</span>
                </div>
                <div class="form-group">
                  <label>{{$t('expert2.field.owner')}} <span class="red">*</span></label>
                  <v-select v-model="expert2.ownerClient" label="text"
                            :options="owners"
                            :filterable="false"
                            @search="onOwnerSearch"
                            @search:focus="onOwnerFocus"
                            :disabled="!isEditable"
                            :class="{invalid : $v.expert2.ownerClient.$error}">
                    <template slot="option" slot-scope="option" v-if="option">
                      <div v-html="option.text"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="expert2 && expert2.ownerClient && expert2.ownerClient.text">
                      <div v-html="expert2.ownerClient.text"
                           @click="$eventBus.$emit('search:focus')"></div>
                    </template>
                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                  </v-select>
                  <div class="red" v-if="$v.expert2.ownerClient.$error">
                    {{$t("realEstate.validation.ownerClient")}}
                  </div>
                </div>
                <!--<div class="form-group">-->
                <!--<div class="row">-->
                <!--<div class="col-12" :class="{invalid : $v.expert2.ownerType.$error}">-->
                <!--<div class="form-check form-check-radio checkbox-inline pl-0"-->
                <!--style="margin-left:-0.8rem">-->
                <!--<label class="form-check-label">-->
                <!--<input class="form-check-input" type="radio" name="ownerType"-->
                <!--value="Physical" v-model="expert2.ownerType">-->
                <!--<span class="form-check-sign"></span>-->
                <!--{{$t("expert2.field.ownerType.physical")}}-->
                <!--</label>-->
                <!--</div>-->
                <!--<div class="form-check form-check-radio checkbox-inline">-->
                <!--<label class="form-check-label">-->
                <!--<input class="form-check-input" type="radio" name="ownerType"-->
                <!--value="Legal" v-model="expert2.ownerType">-->
                <!--<span class="form-check-sign"></span>-->
                <!--{{$t("expert2.field.ownerType.legal")}}-->
                <!--</label>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="red" v-if="$v.expert2.ownerType.$error">-->
                <!--{{$t("realEstate.validation.valueType")}}-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="form-group" v-if="expert2.ownerType === 'Legal'">-->
                <!--<label>{{$t('expert2.field.ownerInn')}} <span class="red">*</span></label>-->
                <!--<the-mask class="form-control" v-model="expert2.ownerInn" mask="#########" masked="masked"></the-mask>-->
                <!--</div>-->
                <div class="form-group">
                  <div class="row">
                    <div class="col-12">
                      <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                    </div>
                    <div class="col-12">
                      <div :class="{invalid : $v.approach.$error}">
                        <div class="form-check pl-0 checkbox-inline">
                          <label class="form-check-label"
                                 style="padding-left:22px !important">
                            <input class="form-check-input" type="checkbox"
                                   v-model="expert2.approachCost"
                            >
                            <span class="form-check-sign"></span>
                            {{$t("realEstate.approach.expense")}}
                          </label>
                        </div>
                        <div class="form-check checkbox-inline">
                          <label class="form-check-label">
                            <input class="form-check-input" type="checkbox"
                                   v-model="expert2.approachIncome"
                            >
                            <span class="form-check-sign"></span>
                            {{$t("realEstate.approach.income")}}
                          </label>
                        </div>
                        <div class="form-check checkbox-inline">
                          <label class="form-check-label">
                            <input class="form-check-input" type="checkbox"
                                   v-model="expert2.approachComparative"
                            >
                            <span class="form-check-sign"></span>
                            {{$t("realEstate.approach.comparative")}}
                          </label>
                        </div>
                      </div>
                      <div class="red" v-if="$v.approach.$error">
                        {{$t("realEstate.validation.approachMethods")}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t('expert2.field.name')}} <span class="red">*</span></label>
                  <input class="form-control" type="text" v-model="expert2.name"/>
                </div>
                <template>
                  <div class="form-group">
                    <label>{{$t("realEstate.field.cadastreNumber")}} <span class="red">*</span></label>
                    <cadastre-input :cadastre-number.sync="expert2.cadastreDocNumber" :invalid="$v.expert2.cadastreDocNumber.$error"/>
                  </div>
                  <div class="red" v-if="$v.expert2.cadastreDocNumber.$error">
                    {{$t("realEstate.validation.cadastreNumber")}}
                  </div>
                  <div class="form-group">
                    <label>{{$t("realEstate.field.areaTotal")}}</label>
                    <numeric-input v-model="expert2.totalGroundArea" :precision="2" :class="{invalid: $v.expert2.totalGroundArea.$error}"></numeric-input>
                  </div>
                  <div class="form-group">
                    <label>{{$t("realEstate.field.areaUseful")}}</label>
                    <numeric-input v-model="expert2.usefulArea" :precision="2" :class="{invalid: $v.expert2.usefulArea.$error}"></numeric-input>
                  </div>
                  <div class="form-group">
                    <label>{{$t("expert2.field.buildingCount")}} <span class="red">*</span></label>
                    <numeric-input :precision="0" v-model="expert2.buildingCount" :class="{invalid: $v.expert2.buildingCount.$error}"></numeric-input>
                  </div>
                  <div class="form-check checkbox-inline">
                    <label class="form-check-label pl-3 font-weight-bold">
                      <input class="form-check-input" type="checkbox"
                             v-model="expert2.displayReport"
                             @change="showReport()"
                             v-if="hasPermission('EXPERT2_DISPLAY_REPORT')"
                      >
                      <span class="form-check-sign"></span>
                      {{$t("report.field.showReport")}}
                    </label>
                  </div>
                  <div class="form-check checkbox-inline">
                    <label class="form-check-label pl-3 font-weight-bold">
                      <input class="form-check-input" type="checkbox"
                             v-model="expert2.displayConclusion"
                             @change="showConclusion()"
                             v-if="hasPermission('EXPERT2_DISPLAY_REPORT')"
                      >
                      <span class="form-check-sign"></span>
                      {{$t("report.field.showConclusion")}}
                    </label>
                  </div>
                </template>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>{{$t("expert2.field.province")}} <span class="red">*</span></label>
                  <v-select v-model="expert2.province" label="name"
                            :options="provinces"
                            :filterable="false"
                            :class="{invalid : $v.expert2.province.id.$error}"
                            @search="onProvinceSearch"
                            @search:focus="onProvinceFocus"
                            @change="onProvinceChange"
                  >
                    <template slot="option" slot-scope="option" v-if="option">
                      <div v-html="option.name"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="expert2 && expert2.province && expert2.province.name">
                      <div v-html="expert2.province.name"
                           @click="$eventBus.$emit('search:focus')"></div>
                    </template>
                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                  </v-select>
                </div>
                <div class="form-group">
                  <label>{{$t("expert2.field.region")}} <span class="red">*</span></label>
                  <v-select v-model="expert2.region" label="name"
                            :options="regions"
                            :filterable="false"
                            :class="{invalid : $v.expert2.region.id.$error}"
                            @search="onRegionSearch"
                            @search:focus="onRegionFocus"
                            @change="onRegionChange"
                  >
                    <template slot="option" slot-scope="option" v-if="option">
                      <div v-html="option.name"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="expert2 && expert2.region && expert2.region.name">
                      <div v-html="expert2.region.name"
                           @click="$eventBus.$emit('search:focus')"></div>
                    </template>
                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                  </v-select>
                </div>
                <div class="form-group">
                  <label>{{$t("realEstate.field.microRegion")}} <span class="red">*</span></label>
                  <select class="form-control"
                          v-model="expert2.microRegionId"
                          :class="{invalid: $v.expert2.microRegionId.$error}"
                  >
                    <option value=""></option>
                    <option :value="option.id" v-for="option in microRegions" :key="option.id">
                      {{option.name}}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>{{$t('expert2.field.address')}} <span class="red">*</span></label>
                  <input type="text" class="form-control" v-model="expert2.address" />
                </div>
                <div class="form-group">
                  <label>{{$t("realEstate.field.evaluator")}} <span class="red">*</span></label>
                  <v-select v-model="expert2.employee" label="text"
                            :options="employees"
                            :filterable="false"
                            @search="onEmployeeSearch"
                            @search:focus="onEmployeeFocus"
                            :class="{invalid : $v.expert2.employee.id.$error}">
                    <template slot="option" slot-scope="option" v-if="option">
                      <div v-html="option.text"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="expert2 && expert2.employee && expert2.employee.text">
                      <div v-html="expert2.employee.text"
                           @click="$eventBus.$emit('search:focus')"></div>
                    </template>
                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                  </v-select>
                  <div class="red" v-if="$v.expert2.employee.$error">
                    {{$t("realEstate.validation.evaluator")}}
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t("expert2.field.evlGoalType")}} <span
                      class="red">*</span></label>
                  <v-select v-model="expert2.evlGoalType"
                            label="typeName"
                            :options="goalTypes"
                            :filterable="false"
                            :disabled="false"
                  >
                    <template slot="option" slot-scope="option" v-if="option">
                      <div v-html="option.typeName"></div>
                    </template>
                    <span slot="no-options"> {{$t("messages.combo.empty")}}</span>
                  </v-select>
                </div>
                <div class="form-group">
                  <label>{{$t('expert2.field.reportNumber')}} <span class="red">*</span></label>
                  <input class="form-control" type="text" v-model="expert2.clientReportNumber" />
                </div>
                <div class="form-group">
                  <label>{{$t("expert2.field.evlEstimatedDate")}} <span class="red">*</span></label>
                  <div>
                    <datepicker
                        class="form-control"
                        format="dd/MM/yyyy"
                        v-model="evlEstimatedDate"
                        :clear-button="true"
                    ></datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="section-header">
                  <h4>{{$t("expert2.field.docsToSubmit")}}</h4>
                </div>
              </div>
              <template v-if="!isPageLoadInit">
                <RealEstateDropZone code="cadastreDropZone"
                                    label="expert2.field.docCadastre"
                                    folder="Cadastre"
                                    :data="expert2.cadastre"
                                    @change="(files) => {expert2.cadastre = files}"
                                    :has-error="$v.expert2.cadastre.$error"
                                    :removeFile="canRemoveFile"
                                    :editable="canSave"
                />

                <RealEstateDropZone code="reportDropZone"
                                    label="expert2.field.docReport"
                                    folder="Report"
                                    :data="expert2.report"
                                    @change="(files) => {expert2.report = files}"
                                    :has-error="$v.expert2.report.$error"
                                    :removeFile="canRemoveFile"
                                    :editable="canSave"
                />

                <RealEstateDropZone code="buildingDropZone"
                                    label="expert2.field.docPhotos"
                                    folder="Building"
                                    :data="expert2.photos"
                                    @change="(files) => {expert2.photos = files}"
                                    :removeFile="canRemoveFile"
                                    :editable="false"
                />
              </template>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <object-history-view :entityType="'DB_EXPERT2'"/>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                  {{$t("action.cancel")}}
                </button>
                <button class="all-btn add-btn" @click="save" :disabled="processing" v-if="canSave">
                  {{$t("action.save")}}
                </button>
                <button class="all-btn add-btn" @click="changeStatusGo('Confirmed')"
                        :disabled="processing"  v-if="showConfirmedButton">{{$t("realEstate.action.confirm")}}
                </button>
                <button class="all-btn btn-primary" @click="changeStatusGo('Evaluated')"
                        :disabled="processing"  v-if="showEvaluatedButton">{{$t("realEstate.action.evaluate")}}
                </button>
                <button class="all-btn edit-btn" @click="changeStatusGo('NotFullyEvaluated')"
                        :disabled="processing" v-if="canReEvaluate">
                  {{$t("realEstate.action.reevaluate")}}
                </button>
                <button class="all-btn delete-btn" @click="deleteExpert2()"
                        v-if="canDeleteExpert2">
                  {{$t("action.delete")}}
                </button>
                <button class="all-btn delete-btn" v-if="canReject" @click="rejectOrder">
                  <i class="fa fa-reply-all"></i>
                  <span>Рад қилиш</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Expert2RejectComment/>
  </div>
</template>

<script>
import {required, requiredUnless, minLength, minValue} from 'vuelidate/lib/validators';
import {TheMask} from 'vue-the-mask';
import Datepicker from 'vuejs-datepicker';
import RealEstateDropZone from '@/views/real-estate/RealEstateDropZone';
import {formatDate, parseDate} from '@/shared/utils';
import Expert2RejectComment from '@/components/Expert2RejectComment';
import initFilterModel from '@/shared/filter';
import AdvancedFilter from '@/shared/filters/advancedFilter';
import CadastreInput from "@/components/CadastreInput.vue";
import {cadastreNumber} from "@/shared/validator-helpers";
import ObjectHistoryView from "@/components/common/ObjectHistoryView.vue";
import {mapState} from "vuex";

export default {
  name: "Expert2Edit",
  components: {
    ObjectHistoryView,
    CadastreInput,
    TheMask,
    Datepicker,
    RealEstateDropZone,
    Expert2RejectComment
  },
  data() {
    return {
      processing: false,
      loading: {
        isDocQrLoading: false,
        isDocLoading: false,
        isPdfLoading: false,
        isPdfQrLoading: false,
        isCDocLoading: false,
        isCPdfLoading: false,
        isCDocQrLoading: false,
        isCPdfQrLoading: false
      },
      isPageLoadInit: false,
      filter: initFilterModel(),
      ownerFilter: initFilterModel(),
      filterProvince: initFilterModel(),
      filterRegion: initFilterModel(),
      filterMicroRegion: new AdvancedFilter(),
      filterAgent: initFilterModel(),
      employeeFilter: initFilterModel(),
      clientTypes: [
        { item: 'Physical', name: 'Жисмоний шахс' },
        { item: 'Legal', name: 'Юридик шахс' }
      ],
      expert2: {
        id: null,
        organizationName: '',
        owner: '',
        ownerClient: null,
        approachCost: false,
        status: 'Pending',
        approachIncome: false,
        approachComparative: false,
        name: '',
        province: {},
        region: {},
        address: '',
        evlGoalType: null,
        // orgInn: '',
        ownerInn: '',
        reportNumber: '',
        clientReportNumber: '',
        cadastreDocNumber: '',
        evlEstimatedDate: null,
        ownerType: 'Physical',
        cadastre: [],
        report: [],
        photos: [],
        microRegionId: null,
        buildingCount: 0,
        totalGroundArea: 0,
        usefulArea: 0,
        employee: null,
        displayReport: false,
        displayConclusion: false,
        borrower: null
      },
      provinces: [],
      regions: [],
      microRegions: [],
      goalTypes: [],
      evlEstimatedDate: null,
      owners: [],
      status: null,
      employees: []
    }
  },
  validations() {
    return {
      expert2: {
        organizationName: {
          required: required
        },
        ownerClient: {
          required: required
        },
        name: {
          required: required
        },
        province: {
          id: {
            required: required
          }
        },
        region: {
          id: {
            required: required
          }
        },
        address: {
          required: required
        },
        evlGoalType: {
          required: required
        },
        // orgInn: {
        //     required: required,
        //     minLength: minLength(9)
        // },
        // ownerInn: {
        //     required: requiredUnless(() => {
        //         return !(this.isLegal)
        //     }),
        //     minLength: minLength(9)
        // },
        clientReportNumber: {
          required: required
        },
        // ownerType: {
        //     required: required
        // },
        cadastre: {
          required,
          minLength: minLength(1)
        },
        report: {
          required,
          minLength: minLength(1)
        },
        /* photos: {
             required,
             minLength: minLength(1)
         }, */
        microRegionId: {
          required: required
        },
        cadastreDocNumber: {
          required: required,
          cadastreNumber: cadastreNumber
        },
        buildingCount: {
          required: requiredUnless(() => {
            return !(this.isTargetBuilding)
          }),
          minValue: minValue(1)
        },
        totalGroundArea: {
          required: requiredUnless(() => {
            return !(this.isTargetBuilding)
          }),
          minValue: minValue(0.01)
        },
        usefulArea: {
          required: requiredUnless(() => {
            return !(this.isTargetBuilding)
          }),
          minValue: minValue(0.01)
        },
        employee: {
          id: {
            required: required
          }
        }
      },
      approach: {
        required: requiredUnless(() => {
          return !(!(this.expert2.approachCost || this.expert2.approachComparative || this.expert2.approachIncome));
        })
      },
      evlEstimatedDate: {
        required: required
      }
    }
  },
  computed: {
    ...mapState(['profile']),
    isLegal() {
      return this.expert2.ownerType === 'Legal'
    },
    canSave() {
      return (this.expert2.status === 'Pending' || this.expert2.status === 'AssignedToEvaluator' || this.expert2.status === 'NotFullyEvaluated');
    },
    showReportButton() {
      return (this.expert2.status === 'NotFullyEvaluated' || this.expert2.status === 'Confirmed') && this.expert2.targetId && this.expert2.id > 0 && this.expert2.targetEvlPrice > 0;
    } ,
    showConfirmedButton() {
      return this.expert2.targetId && this.expert2.id && this.expert2.id > 0 && this.expert2.status === 'Evaluated' && this.hasPermission('EXPERT2_REAL_ESTATE_CONFIRMED');
    },
    canReEvaluate() {
      return (this.expert2.status === 'Confirmed' || this.expert2.status === 'Evaluated') && this.hasPermission('EXPERT2_EDIT');
    },
    canDeleteExpert2(){
      return (this.expert2.status !== 'Confirmed') && this.hasPermission('EXPERT2_DELETE');
    },
    canReject() {
      return this.hasPermission('EXPERT2_EDIT') && (this.expert2.status === 'AssignedToEvaluator' || (this.expert2.status === 'NotFullyEvaluated' && this.isUserDirector));
    },
    isEditable() {
      return this.expert2.status !== 'Confirmed';
    },
    canRemoveFile() {
      return this.status && this.status!=='Evaluated' && this.status!== 'Confirmed' && this.status!== 'Rejected' && this.hasPermission('EXPERT2_IMAGE_DELETE');
    },
    isTargetBuilding() {
      return this.expert2 && this.expert2.targetType && this.expert2.targetType === 'Building'
    },
    showEvaluatedButton() {
      return this.expert2.status === 'NotFullyEvaluated' && this.hasPermission('EXPERT2_REAL_ESTATE_EVALUATE');
    },
    isUserDirector() {
      return this.profile && this.profile.username === 'shohrux';
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      const promises = [
        this.$http.post('/admin/expert2/init', this.filter)
      ];

      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(this.$http.get(`/admin/expert2/${id}`))
      }

      Promise.all(promises).then(function (values) {
        const initData = values[0].data;
        vm.goalTypes = initData.evlGoalTypes;

        if (values.length >= 2) {
          const editData = values[1].data;
          vm.evlEstimatedDate = parseDate(editData.evlEstimatedDate);
          vm.expert2 = editData;
          vm.status = editData.status;
          vm.isPageLoadInit = false;
        }
      })
    },
    onProvinceChange() {
      if (this.expert2.province.id > 0) {
        if (this.regions.length > 0) {
          this.expert2.region = {}
        }
      }
    },
    onRegionChange() {
      if (this.expert2.region.id > 0) {
        this.onMicroRegionFocus();
      }
    },
    cancel() {
      this.$router.push('/expert2/list')
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.processing = true;

      if (this.evlEstimatedDate) {
        this.expert2.evlEstimatedDate = formatDate(this.evlEstimatedDate);
      }

      this.$http.post('admin/expert2/save/', this.expert2)
          .then(res => {
            if (res && res.data && (res.data.status ==='FAIL' || res.data.status === 'SUCCESS')) {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.expert2.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/expert2/list')
            } else {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('messages.expert2.error'),
                type: 'error'
              });
            }
            this.processing = false;

          }).catch(({response}) => {
        console.log('error')
        console.log(response);
        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });
        this.processing = false
      })
    },
    changeStatusGo(status) {
      const vm = this;
      this.processing = true;
      this.isPageLoadInit = true;

      const data = {
        objectId: this.expert2.id,
        status: status
      };
      this.$http.post('admin/expert2/status', data)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$root.$t('messages.common.success'),
                text: this.$root.$t('messages.expert2.statusSuccess'),
                type: 'success'
              });
              vm.expert2.status = status;
              vm.status = status;
              if (status === 'Confirmed') {
                this.$router.push('/expert2/edit/' + this.expert2.id)
              }
              this.init()
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: res.data.message.includes('approach') ? this.$t('expert2.validation.'+ res.data.message) : this.$t('messages.expert2.statusError'),
                type: 'warning'
              });
            }
            this.processing = false;
            this.isPageLoadInit = false;
          }, () => {
            this.$swal({
              title: this.$root.$t('messages.common.error'),
              text: this.$root.$t('messages.realEstate.statusError'),
              type: 'error'
            });
            this.processing = false;
            this.isPageLoadInit = false;
          });
    },

    deleteExpert2: function () {
      this.processing = true;
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('expert2.field.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          console.log(this.expert2.id);
          this.$http.delete('/admin/delete/expert2/' + this.expert2.id)
              .then((res) => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('expert2.field.deleteSuccess'),
                    type: 'success'
                  });
                  this.$router.push('/expert2/list');
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('expert2.field.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        } else {
          this.processing = false;
        }
      });
    },
    expert2ReportPdf: function (asset) {
      this.loading.isPdfLoading = true;
      this.downloadFile('/v2/expert2Report/pdf/' + asset.hashUuid + '/WITH_SIGNATURE',
          'Хисобот ' + asset.owner + '.pdf',
          'application/pdf',
          'isPdfLoading');
    },
    expert2ReportPdfQrCode: function (asset) {
      this.loading.isPdfQrLoading = true;
      this.downloadFile('/v2/expert2Report/pdf/' + asset.hashUuid + '/WITH_QR_CODE',
          'Хисобот ' + asset.owner + '.pdf',
          'application/pdf',
          'isPdfQrLoading');
    },
    expert2ReportDoc: function (asset) {
      this.loading.isDocLoading = true;
      this.downloadFile('/v2/expert2Report/doc/' + asset.hashUuid + '/WITH_SIGNATURE',
          'Хисобот ' + asset.owner + '.doc',
          'application/doc',
          'isDocLoading');
    },
    expert2ReportDocQrCode: function (asset) {
      this.loading.isDocQrLoading = true;
      this.downloadFile('/v2/expert2Report/doc/' + asset.hashUuid + '/WITH_QR_CODE',
          'Хисобот ' + asset.owner + '.doc',
          'application/doc',
          'isDocQrLoading');
    },
    downloadFile: function (url, name, type, loading) {
      this.$http.get(url, {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: type});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            link.click();
            this.loading[loading] = false;
          })
          .catch(err => {
            console.log(err);
            this.loading[loading] = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
            }
          })
    },
    rejectOrder() {
      this.$eventBus.$emit('Expert2RejectComment', this.expert2.id, false, "Expert2", false);
    },
    onOwnerSearch(searchTxt, loading) {
      loading(true);
      this.owners = [];
      this.ownerFilter.search = searchTxt;
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onOwnerFocus() {
      this.owners = [];
      this.ownerFilter.search = '';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onProvinceFocus() {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onProvinceSearch(searchTxt, loading) {
      loading(true);
      this.provinces = [];
      this.filterProvince.search = searchTxt;
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionSearch(searchTxt, loading) {
      loading(true);
      this.regions = [];
      this.filterRegion.search = searchTxt;
      this.filterRegion.provinceId = (this.expert2.province && this.expert2.province.id) ? this.expert2.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionFocus() {
      this.regions = [];
      this.filterRegion.provinceId = (this.expert2.province && this.expert2.province.id) ? this.expert2.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onMicroRegionFocus() {
      this.microRegions = [];
      this.filterMicroRegion.region = (this.expert2.region && this.expert2.region.id) ? this.expert2.region.id : 0;
      this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
          .then(res => {
            this.microRegions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onEmployeeSearch(searchTxt, loading) {
      loading(true);
      this.employees = [];
      this.employeeFilter.search = searchTxt;
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onEmployeeFocus() {
      this.employees = [];
      this.employeeFilter.search = '';
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    showReport() {
      this.$http.post('admin/expert2/show-report/' + this.expert2.id + '/' + this.expert2.displayReport)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.expert2.statusSuccess'),
                type: 'success'
              });
            } else if (res && res.data && res.data.status === 'FAIL') {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.expert2.error'),
                type: 'warning'
              });
            }
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.expert2.error'),
              type: 'error'
            });
          });
    },
    showConclusion() {
      this.$http.post('admin/expert2/show-conclusion/' + this.expert2.id + '/' + this.expert2.displayConclusion)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.expert2.statusSuccess'),
                type: 'success'
              });
            } else if (res && res.data && res.data.status === 'FAIL') {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.expert2.error'),
                type: 'warning'
              });
            }
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.expert2.error'),
              type: 'error'
            });
          });
    },
    addEditItem() {
      this.loading = true;
      if (this.expert2.id) {
        this.$http.get(`admin/expert2/${this.expert2.id}/item/Building/list`)
            .then(res => {
              const items = res.data;
              if (items.length > 1) {
                this.$router.push({
                  path: `/expert2/${this.expert2.id}/item-method/real-estate`,
                  query: {evlObjectType: 'Building'}
                });
              } else if (items.length > 0){
                this.$router.push({
                  path: `/expert2/${this.expert2.id}/real-estate/requirement/edit/${items[0].id}`,
                  query: {hasEdit: true, objectType: 'Building'}
                });
              } else {
                this.$router.push({
                  path: `/expert2/${this.expert2.id}/real-estate/requirement/new`,
                  query: {hasEdit: true, objectType: 'Building'}
                });
              }
              this.loading = false;
            }, err => {
              console.log(err);
              this.loading = false;
            })
      }
    }
  },
  created() {
    this.filterProvince.page.size = 1000;
    this.filterRegion.page.size = 1000;
    this.filterMicroRegion.pageFilter.size = 10000;
    this.init()
  }
}
</script>

<style scoped>

</style>